import React, { Component } from 'react'
import Utils from '../../common/lib/utils'
import './ad.less'
const adParam = {
  p: '', // 广告id
  s: '', // showid
  sid: '', // pvid
  aw: 'w',
  k: '', // showid_en
  rst: 'h5,img'
}
export default class AdComponent extends Component {
  requestAD (op) {
    if (!op.id) return
    const userAgent = navigator.userAgent.toLowerCase()
    const param = adParam
    param.p = op.id
    param.ios = (userAgent.indexOf('mac') !== -1 || userAgent.indexOf('ios') !== -1)
    param.compatible = 1
    // 将mac也包含进IOS系统中
    Utils.getScript('//html.atm.youku.com/html?' + Utils.paramToUrl(param), { charset: 'gbk' })
  }

  componentDidMount () {
    const _param = Utils.getUrlParam()
    let _id = ''// parseInt(this.props.data.adId) === 407 ? 380 : this.props.data.adId
    if (parseInt(this.props.data.adId) === 407) {
      _id = 380
    } else if (parseInt(this.props.data.adId) === 501) {
      _id = 864
    } else {
      _id = this.props.data.adId
    }
    if (_param.debugAd === '1' && (_id === 380 || _id === 864)) {
      this.requestAD({ id: _id })
    }
  }

  render () {
    let _id = ''
    if (parseInt(this.props.data.adId) === 407) {
      _id = 380
    } else if (parseInt(this.props.data.adId) === 501) {
      _id = 864
    } else {
      _id = this.props.data.adId
    }
    return (
      <div id={`ab_${_id}`} className='ad-wrap' data-adid={this.props.data.adId} />
    )
  }
}
